import ApplyRecord from './apply_record.vue'

export default {
    path: 'applyRecord',
    component: ApplyRecord
}
